import ArticleAppBarItems from './ArticleAppBarItems';
import LandingAppBarItems from './LandingAppBarItems';

const AppbarModes = {
  LANDING: LandingAppBarItems,
  ARTICLE: ArticleAppBarItems,
};

export default AppbarModes;
